module.exports = __webpack_public_path__ + "img/thumbnail_Nyala_j_normal.8a03d8f8.png";